import React, {useState, useEffect} from 'react'
import Button from '../../templates/Button';
import InputField from '../../templates/InputField'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { SUCCESS, FAIL, LOADING } from '../../../redux_store/actionTypes';
import toast from '../../templates/ToastMessage'
import LoadingModal from '../../templates/modals/LoadingModal';
import { addPromo, getPromotionDetailsById } from '../../../redux_store/promotions/promotion_thunk';
import { generatePromoCode } from '../../../utils';
import DropDown from '../../templates/dropdowns/Dropdown';
import BasicDropDown from '../../templates/dropdowns/BasicDropDown';

const ManagePromotionsPage = () => {
  const [details, setDetails] = useState({
    promo_code: '',
    promo_type: '',
    value: '',
    expiry_date: '',
    total_usage: ''
  });
  const dispatch = useDispatch();
  const [state, setState] = useState('create');
  const params = useParams();
  const [user, setUser] = useState(null)
  const location = useLocation();
  const navigator = useNavigate();
  const { status, message, promotions } = useSelector((state)=>state.promotion);

  useEffect(()=>{
    if(params.id){
      setState('edit');
      dispatch(getPromotionDetailsById(params.id));
    }
    // eslint-disable-next-line
  }, [params.id]);

  useEffect(()=>{
    if(promotions){
      setDetails(promotions[0]);
    }
  }, [promotions]);

  useEffect(()=>{
    if(location.state && Object.keys(location.state).length > 0){
      setUser(location.state);
    }
    // eslint-disable-next-line
  }, [location.pathname])

  useEffect(()=>{
    const promo_code = generatePromoCode();
    setDetails({...details, promo_code});
    // eslint-disable-next-line
  }, []);

  useEffect(()=>{
    if(status === FAIL){
      toast({message, status});
    }else if(status === SUCCESS){
      toast({message, status});
      navigator(-1);
    }
    // eslint-disable-next-line
  }, [status]);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if(user){
      dispatch(addPromo({...details, user_id: user.id}));
    }else{
      dispatch(addPromo(details));
    }
  }

  const handleInputChange = (e) => {
    const {name, value} = e.target;
    setDetails({...details, [name]:value});
  }

  return (
    <form onSubmit={handleFormSubmit} className='grid gap-y-5 gap-x-8 py-10 px-16 grid-cols-2 bg-white shadow-md rounded'>
      {status === LOADING && <LoadingModal message={'Please wait...'} />}
      {user &&      
        <div>
          <p className='text-gray-500 font-medium text-sm'>User</p>
          <BasicDropDown 
            disable={true}
            value={user.surname}
            items={[`${user.surname} ${user.other_names}`]}
          />
        </div>
      }
      <div>
        <p className='text-gray-500 font-medium text-sm'>Promo Code (auto-generated)</p>
        <InputField 
          type={'text'}
          name="promo_code"
          isRequired={true}
          onChange={handleInputChange}
          value={details.promo_code}
        />
      </div>
      <div>
        <p className='text-gray-500 font-medium text-sm'>Promotion Type</p>
        <div className='w-full'>
          <DropDown
            onSelect={(val)=>{
              setDetails({...details, promo_type: val});
            }}
            selected={details.promo_type}
            prefix={''}
            defaultSelect={''}
            items={['Percentage', 'Value']}
          />
        </div>
      </div>
      <div>
        <p className='text-gray-500 font-medium text-sm'>
          Promo Value ({details.promo_type === 'Value' ? 'in GHC': details.promo_type === 'Percentage' ? 'in %': 'N/A'})
        </p>
        <InputField 
          type={'text'}
          name="value"
          isRequired={true}
          onChange={handleInputChange}
          value={details.value}
        />
      </div>
      <div>
        <p className='text-gray-500 font-medium text-sm'>
          Expiry Date
        </p>
        <InputField 
          type={'date'}
          name="expiry_date"
          isRequired={true}
          onChange={handleInputChange}
          value={details.expiry_date}
        />
      </div>
      <div>
        <p className='text-gray-500 font-medium text-sm'>
          Number of times to be applied
        </p>
        <InputField 
          type={'number'}
          name="total_usage"
          isRequired={true}
          onChange={handleInputChange}
          value={details.total_usage}
        />
      </div>
      <div className='col-span-2'>
        <Button
          type="submit"
          label={state === 'edit' ? 'Update' : 'Submit'}
          width="w-full"
          bgColor={'wayrideBgColor'}
        />
      </div>
    </form>  
  )
}

export default ManagePromotionsPage